import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchCategories, clearCategoriesErrors, deleteCategory } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  categories: PropTypes.object,
  categoryDelete: PropTypes.bool,
  // onOptionDisable: PropTypes.func,
};

class ShowCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.categoryDelete && (this.state.delete || nextProps.categories.delete)) {
      const categories = nextProps.categories;
      categories.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Category deleted!',
        categories,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteCategory(this.state.deleteId));
    this.props.dispatch(fetchCategories());
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearCategoriesErrors());
    this.props.dispatch(fetchCategories());
  }
  renderRowsTable() {
    return this.props.categories.results.map((category, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{category.name}</TableRowColumn>
        <TableRowColumn key={i}>{category.description}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDelete={() => this.handleOpen(category.id)}
            onEdit={`/categories/${category.id}`}
            onView={`/categories/view/${category.id}`}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Category"
          dialogMessage="Do you really want to delete this category?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Description</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowCategories.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowCategories.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.categories.error,
    categoryDelete: state.categories.categoryDelete,
  };
}

export default connect(mapStateToProps)(ShowCategories);



// WEBPACK FOOTER //
// ./src/components/categories/ShowCategories.js